import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VTabs,[_c(VTab,{key:"company",attrs:{"to":"/company/general"}},[_vm._v("General settings")]),_c(VTab,{key:"billing",attrs:{"disabled":!_vm.miscStore.user.is_admin,"to":"/company/billing"}},[_vm._v("Billing")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }